<div class="financial-simulator-mobile">
    <div class="financial-simulator">
        <div class="summary">
            <!-- <div class="logo-coche">
                <img [src]="'./assets/img/themes/' + brand + '/models/' + model + '_icon.png'" alt="" />
            </div> -->

            <div class="rows">
                <div class="title">
                    <span class="text-title">{{ brand }} {{ model }}</span>
                    <div>
                        <span class="text-title">{{ data.price | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="label-value">
                        <span class="text-line">{{ installmentMonthlyGrossAmount | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.installmentMonthlyGrossAmount | myDecimalPipe: 2 | myCurrencyPipe: '€/mes' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="label-value">
                        <span class="text-line">{{ downPaymentGrossAmount | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.downPaymentGrossAmount | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="label-value">
                        <span class="text-line">{{ duration | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.duration }} meses</span>
                    </div>
                </div>

                <div *ngIf="!moreInformationButtonExpanded" class="button-box">
                    <button pripple="" class="button-more-information" type="submit" (click)="onMoreInformation()">
                        <span class="p-button-label-left">{{ moreInformationButton | translate }}</span>

                        <i class="ri-arrow-down-s-line custom-cart-icon"></i>
                    </button>
                </div>
                <!--
                <p-divider class="p-divider-horizontal" layout="horizontal"></p-divider>
 -->
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ nominalRate | translate }} / {{ aprcRate | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.nominalRate | myDecimalPipe: 2 | myPercentPipe }}</span>
                        <span class="text-result"> / </span>
                        <span class="text-result">{{ data.aprcRate | myDecimalPipe: 2 | myPercentPipe }}</span>
                    </div>
                </div>
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ amountFinanced | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.amountFinanced | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ totalInterestGrossAmount | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.totalInterestGrossAmount | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ totalCreditCost | translate }}</span>
                    </div>
                    <div class="value__I764-1181-498-497">
                        <span class="text-result">{{ data.totalCreditCost | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ totalAmountDue | translate }}</span>
                    </div>
                    <div class="value__I764-1181-498-495">
                        <span class="text-result">{{ data.totalAmountDue | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ installmentTotalGrossAmount | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.installmentTotalGrossAmount | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>

                <p-divider *ngIf="moreInformationButtonExpanded" class="p-divider-horizontal" layout="horizontal"></p-divider>

                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ installmentFirstGrossAmount | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.installmentFirstGrossAmount | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
                <div *ngIf="moreInformationButtonExpanded" class="row">
                    <div class="label-value">
                        <span class="text-line">{{ installmentLastGrossAmount | translate }}</span>
                    </div>
                    <div class="value">
                        <span class="text-result">{{ data.installmentLastGrossAmount | myDecimalPipe: 2 | myCurrencyPipe: '€' }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="moreInformationButtonExpanded" class="button-box">
                <button pripple="" class="button-more-information" type="submit" (click)="onMoreInformation()">
                    <span class="p-button-label-left">{{ lessInformationButton | translate }}</span>

                    <i class="ri-arrow-up-s-line custom-cart-icon"></i>
                </button>
            </div>
            <!--
            <p-divider *ngIf="moreInformationButtonExpanded" class="p-divider-horizontal" layout="horizontal"></p-divider>
             -->
        </div>

        <div class="panel-simulator">
            <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
                <span class="text-title">{{ modifyConditionsFinancing | translate }}</span>

                <div class="simulator-container">
                    <div class="simulator-card">
                        <div class="type-financiation">
                            <p-selectButton
                                id="typeFinancialProduct"
                                formControlName="typeFinancialProduct"
                                class="type-financiation-options"
                                [options]="financialProductOptions"
                                optionLabel="label"
                                optionValue="code"
                                (onOptionClick)="onChangeFinancialProduct($event)"
                            ></p-selectButton>

                            <div class="text-info">
                                <i class="ri-information-line text-info-icon"></i>
                                <span *ngIf="isMultiCreditSelected" class="text-info-label">{{ multiOptionCreditConditions | translate }}</span>
                                <span *ngIf="!isMultiCreditSelected" class="text-info-label">{{ classicCreditConditions | translate }}</span>
                            </div>
                        </div>

                        <div class="fields">
                            <div class="credit-duration">
                                <p-dropdown
                                    id="duration"
                                    formControlName="duration"
                                    class="p-dropdown"
                                    [options]="periods"
                                    placeholder="{{ creditDuration | translate }}"
                                    optionLabel="label"
                                    inputId="float-label"
                                    (onChange)="onChangeDurationFinancing($event)"
                                >
                                    <ng-template pTemplate="selectedItem">
                                        <div class="flex align-items-center gap-2" *ngIf="selectedDuration">
                                            <span class="float-label-dropdown">{{ creditDuration | translate }}</span>

                                            <div class="data-field-value-dropdown-item-selected">{{ selectedDuration.label }}</div>
                                        </div>
                                    </ng-template>
                                    <ng-template let-duration pTemplate="item">
                                        <div class="flex align-items-center gap-2">
                                            <div class="selected-item-dropdown data-field-value-dropdown">
                                                {{ duration.label }}
                                                <i *ngIf="duration == selectedDuration" class="ri-check-line class-icono-component"></i>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>

                            <div class="slider">
                                <div class="slider-row">
                                    <label class="slider-row-label">{{ downPaymentGrossAmount | translate }} </label>

                                    <div class="slider-row-input">
                                        <input
                                            id="downPaymentGrossAmount"
                                            type="text"
                                            pInputText
                                            formControlName="downPaymentGrossAmount"
                                            class="label-left w-full"
                                            (keyup)="onChangeDownPaymentGrossAmount($event)"
                                            required
                                        />
                                        <label for="downPaymentGrossAmount" class="label-right">€</label>
                                    </div>
                                </div>

                                <div class="slider-content">
                                    <p-slider
                                        id="downPaymentGrossAmountSlider"
                                        formControlName="downPaymentGrossAmountSlider"
                                        [min]="downPaymentGrossAmountRangeMin"
                                        [max]="downPaymentGrossAmountRangeMax"
                                        class="w-full slider-component"
                                        (onChange)="onChangeDownPaymentGrossAmountSlider($event)"
                                    ></p-slider>

                                    <div class="slider-content-bottom-row">
                                        <label class="label-left">{{
                                            downPaymentGrossAmountRangeMin | myDecimalPipe: 2 | myCurrencyPipe: '€'
                                        }}</label>
                                        <label class="label-right">{{
                                            downPaymentGrossAmountRangeMax | myDecimalPipe: 2 | myCurrencyPipe: '€'
                                        }}</label>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="isMultiCreditSelected" class="slider">
                                <div class="slider-row">
                                    <label for="annualMileage" class="label-left">{{ annualMileage | translate }} </label>
                                    <label for="annualMileage" class="label-right"> {{ selectedAnnualMileage }} Km </label>
                                </div>
                                <div class="slider-content">
                                    <p-slider
                                        id="annualMileageSlider"
                                        formControlName="annualMileageSlider"
                                        [min]="annualMileagesRangeMin"
                                        [max]="annualMileagesRangeMax"
                                        class="w-full slider-component"
                                        (onChange)="onChangeAnnualMileageSlider($event)"
                                    ></p-slider>

                                    <div class="slider-content-bottom-row">
                                        <label class="label-left">{{ annualMileagesRangeMin }} </label>
                                        <label class="label-right">{{ annualMileagesRangeMax }} Km </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line-separator"></div>

                    <div class="management-costs">
                        <div class="label-group">
                            <span class="text-paragraph-description">{{ formalisationCommission | translate }} </span>
                            <i
                                class="ri-information-line"
                                style="color: blue"
                                data-title="La comisión de formalización es el % que vas a pagar a la financiera por realizar una serie de gestiones administrativas para formalizar la operación. Es un porcentaje sobre el importe del préstamo."
                            ></i>
                        </div>
                        <div class="option-group">
                            <p-selectButton
                                id="commissionIncluded"
                                class="p-selectbutton"
                                [options]="commissionIncluded"
                                formControlName="commissionIncluded"
                                optionLabel="label"
                                optionValue="code"
                                (onOptionClick)="onChangeCommissionIncluded($event)"
                            ></p-selectButton>
                        </div>
                    </div>
                    <div class="line-separator"></div>

                    <div class="insurance">
                        <div class="label-group">
                            <span class="text-paragraph-description">{{ paymentProtectionInsurance | translate }} </span>
                            <i
                                class="ri-information-line"
                                style="color: blue"
                                data-title="Hemos diseñado un seguro de protección de pagos que te cuida en caso de que se presente un imprevisto"
                            ></i>
                        </div>

                        <div class="option-group">
                            <p-selectButton
                                id="paymentInsurance"
                                class="p-selectbutton"
                                [options]="paymentInsurance"
                                formControlName="paymentInsurance"
                                optionLabel="label"
                                optionValue="code"
                                (onOptionClick)="onChangePaymentInsurance($event)"
                            ></p-selectButton>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="actions-layer">
        <!--
        <button pripple="" class="button-cancel" type="button" [disabled]="cancelButtonDisabled" (click)="onClicButtonCancel()">
            <span class="p-button-label-right">{{ cancelButton | translate }}</span>
        </button>

        <button pripple="" class="button-save" type="submit" [disabled]="saveButtonDisabled" (click)="onSubmit(formGroup.value)">
            <span class="p-button-label-left">{{ calculateButton | translate }}</span>
        </button>
 -->

        <button pripple="" class="button-secondary button-cancel" type="button" [disabled]="cancelButtonDisabled" (click)="onClicButtonCancel()">
            <span class="p-button-label-right">{{ cancelButton | translate }}</span>
        </button>

        <button pripple="" class="button-primary button-save" type="submit" [disabled]="saveButtonDisabled" (click)="onSubmit(formGroup.value)">
            <span class="p-button-label-left">{{ calculateButton | translate }}</span>
        </button>
    </div>
</div>
